module.exports = __webpack_public_path__ + "static/maptruck-v3-94f4f5828541771c9050799d2dca7c6f.png";